import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import Styles from "./home.module.css";
import { Calendar, globalizeLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import globalize from "globalize";
import { FaCircleArrowLeft, FaCircleArrowRight } from "react-icons/fa6";
import { ComplianceCalendar } from "../../../Services/APIrequests";
import { warningSwal } from "../../../Util/Toast";
import parse from "html-react-parser";

const localizer = globalizeLocalizer(globalize);

const MyToolbar = (props) => {
  const goToBack = () => {
    let mDate = props.date;
    let newDate = moment(mDate).subtract(1, "month").toDate();
    props.onNavigate("prev", newDate);
  };

  const goToNext = () => {
    let mDate = props.date;
    let newDate = moment(mDate).add(1, "month").toDate();
    props.onNavigate("next", newDate);
  };

  const label = () => {
    let date = props.date;
    return (
      <span>
        <b>{moment(date).format("MMMM YYYY")}</b>
      </span>
    );
  };

  return (
    <div className={Styles.toolbar}>
      <FaCircleArrowLeft onClick={goToBack} className={Styles.arrow} />
      <span className={Styles.label}>Compliance Calendar &nbsp;{label()}</span>
      <FaCircleArrowRight onClick={goToNext} className={Styles.arrow} />
    </div>
  );
};

const Complaints = () => {
  const [events, setEvents] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(moment().format("YYYY-MM"));
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [categoryTabs, setCategoryTabs] = useState(["All"]); // Initially just 'All'

 

  const handleEventClick = (event) => {
  if (event?.complianceCalendarUrl) {
    window.open(event.complianceCalendarUrl, "_blank");
  } else {
    warningSwal("No URL available for this event.");
  }
};


  const handleDateClick = (date) => {
    const selected = moment(date).format("YYYY-MM-DD");
    setSelectedDate(selected);
    filterEvents(selected, activeCategory);
  };

  const filterEvents = (date = null, category = "All") => {
    let filtered = events;

    if (category !== "All") {
      filtered = filtered.filter(
        (event) => event.category?.toLowerCase() === category.toLowerCase()
      );
    }

    if (date) {
      filtered = filtered.filter(
        (event) => moment(event.start).format("YYYY-MM-DD") === date
      );
    }

    setFilteredEvents(filtered);
  };

  const fetchEvents = async (startMonth, endMonth) => {
    try {
      const response = await ComplianceCalendar(startMonth, endMonth);
      if (response?.data?.entries?.length > 0) {
        const formattedEvents = response.data.entries.map((event) => ({
          title: event.title,
          description: event.description,
          start: new Date(event.date),
          end: new Date(event.date),
          complianceCalendarUrl: event.complianceCalendarUrl || "",
          colourCode: event.bgColor,
          category: event.categoryName || "OTHERS",
        }));

        // Extract unique category names from API data
        const categories = [
          "All",
          ...new Set(response.data.entries.map((e) => e.categoryName)),
        ];
        setCategoryTabs(categories);

        setEvents(formattedEvents);
        filterEvents(selectedDate, activeCategory);
      } else {
        setEvents([]);
        setFilteredEvents([]);
        setCategoryTabs(["All"]);
      }
    } catch (error) {
      console.error(
        "Error fetching events:",
        error.response?.data?.message || error.message
      );
      setEvents([]);
      setFilteredEvents([]);
      setCategoryTabs(["All"]);
    }
  };

  useEffect(() => {
    fetchEvents(currentMonth, currentMonth);
  }, [currentMonth]);

  useEffect(() => {
    filterEvents(selectedDate, activeCategory);
  }, [activeCategory, selectedDate, events]);

  const dayPropGetter = useCallback(
    (date) => {
      const highlightDates = events.map((event) =>
        moment(event.start).format("YYYY-MM-DD")
      );
      if (highlightDates.includes(moment(date).format("YYYY-MM-DD"))) {
        return {
          style: {
            backgroundColor: "#d3eecc",
            color: "#fff",
          },
        };
      }
      return {};
    },
    [events]
  );

  return (
    <div className={Styles.complaints_container}>
      <h1 className={Styles.abouth1}>Compliance Calendar</h1>

      <div className={Styles.compilance_main_container}>
        <div
          className={Styles.complaints_containerbox}
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <Calendar
            localizer={localizer}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 500 }}
            views={["month"]}
            toolbar={true}
            dayPropGetter={dayPropGetter}
            components={{
              toolbar: MyToolbar,
            }}
            onNavigate={(date) =>
              setCurrentMonth(moment(date).format("YYYY-MM"))
            }
            onSelectSlot={(slotInfo) => handleDateClick(slotInfo.start)}
            selectable
          />
        </div>

        <div
          className={Styles.Complaints_events}
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <h3 className={Styles.Complaints_events_header}>Month Events</h3>

          <div className={Styles.CalendartabsContainer}>
            {categoryTabs.map((cat) =>
              cat ? ( // ✅ Hide tabs with null or undefined
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`${Styles.CalendartabButton} ${
                    activeCategory === cat ? Styles.CalendaractiveTab : ""
                  }`}
                >
                  {cat}
                </button>
              ) : null
            )}
          </div>

        <div className={Styles.Complaints_events_content}>
  {filteredEvents.length > 0 ? (
    Object.entries(
      filteredEvents.reduce((acc, event) => {
        const eventDate = moment(event.start).format("YYYY-MM-DD");
        if (!acc[eventDate]) acc[eventDate] = [];
        acc[eventDate].push(event);
        return acc;
      }, {})
    ).map(([date, eventsForDate], index) => (
      <div key={index} className={Styles.events}>
        <div className={Styles.events_complaints}>
          <div>
            <span>{moment(date).format("DD MMM, YYYY")}</span>
          </div>
          <div className={Styles.eventDetails}>
            {eventsForDate.map((event, idx) => (
              <div
                key={idx}
                className={Styles.event}
                style={{ backgroundColor: event.colourCode }}
                onClick={() => handleEventClick(event)} // <-- Entire card is clickable
              >
                <h3 className={Styles.ComplianceCalendar_title}>
                  {event.title}
                </h3>
                <p
                  className={Styles.ComplianceCalendar_description}
                  style={{
                    cursor: event.complianceCalendarUrl ? "pointer" : "default",
                  }}
                >
                  {parse(event.description || "")}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    ))
  ) : (
    <p style={{ textAlign: "center", fontWeight: "800" }}>
      No events found for this category/month.
    </p>
  )}
</div>

        </div>
      </div>
    </div>
  );
};

export default Complaints;
